import { DELIVERY_STATES } from '../../../lib/deliveryStates';

// The two non-state gates, resolved from the detail by the caller. Both are primitives on purpose:
// this predicate keeps its own vocabulary and learns nothing about where the fields sit on the wire —
// which is what let the carrier policy move inside `carrier` (CBX-10954) without touching it. `null`
// means «not decidable here», and it now covers three situations: the backend has not shipped the
// field, it arrived mistyped, or — since the nesting — the delivery carries **no transportista at
// all**, so there is no policy to read. All three fail open below.
export interface ExtendableGates {
  isReturn: boolean | null;
  carrierAllowsExtension: boolean | null;
}

// «Ampliar custodia» only makes sense while the parcel is waiting in the «buzón», so the state gate
// is `stored` alone, matched case-insensitively and FAIL-CLOSED like every sibling predicate.
// `expired` is out of v1: extending does not un-expire (that case needs «Habilitar recogida» too,
// and neither the order nor the owner is decided).
const EXTENDABLE_STATES = new Set<string>([DELIVERY_STATES.stored]);

// The two gates that are not about state FAIL OPEN — an absent flag means «extendable», mirroring
// the legacy's `?? 1` default. Deliberately the inverse of the box-status notice's fail-closed: a
// notice that guesses is worse than one that stays quiet, but an ACTION never offered is a feature
// that does not exist. The backend's error codes stay the hard gate, and the agent gets a mapped,
// citable rejection instead of an invisible row.
export function isExtendable(status: string, gates: ExtendableGates): boolean {
  if (!EXTENDABLE_STATES.has(status.toLowerCase())) return false;
  if (gates.isReturn === true) return false;
  if (gates.carrierAllowsExtension === false) return false;
  return true;
}
